
import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function callCreatePasswordApi(username, password,newpassword, component) {
  const Authorization = "bearer " + localStorage.getItem("token");
    fetch(`${API_URL}rest/V1/rider/changePassword`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept, Authorization },
      body: JSON.stringify({
        data: {
          username: username,
          password: password,
          newpassword:newpassword
        },
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          notify.show("Network Failure", "error");
        }
        return response.json();
      })
      .then(function (result) {
        if (result[0] && result[0].status=== "failure") {
        console.log(result)
        component.setState({ isloading: false ,modalChange: false});
        notify.show(result[0].message, "error");
        } else {
          component.setState({ isloading: false ,modalChange: false});
          notify.show(result[0].message, "success");
        }
        component.setState({ isloading: false });
      });
  };


// WEBPACK FOOTER //
// ./src/utility/api/callCreatePasswordApi.js